/**
 * **Verbrauch ohne gemessene Erzeugung** (HM-171). Speist ein Haus ein, ohne
 * dass das Messkonzept eine Erzeugung führt — ein Balkonkraftwerk hinter dem
 * Zweirichtungszähler —, dann ist der Verbrauch dort der Netzbezug, und ihm
 * fehlt der PV-Strom, der im Haus blieb. Wie viel das war, weiß niemand
 * (Regel 9); der Verbrauch bleibt deshalb stehen, aber nicht ohne diesen Satz.
 *
 * Die Bedingung steht an den Größen, nicht am Schlüssel der Vorlage: Jede
 * Einspeisung ohne Erzeugung bedeutet dasselbe.
 */
export const UNMETERED_GENERATION_NOTE = "ohne selbst verbrauchten PV-Strom – die Erzeugung wird nicht gemessen";

export function consumptionLacksUnmeteredGeneration(quantities: readonly string[]): boolean {
  return quantities.includes("grid_export") && quantities.includes("consumption") && !quantities.includes("generation");
}
